import { Input, Label } from "@woodmac-hycb/form-input";
import { Col, Row } from "@woodmac-hycb/layout";

function BoundaryAlert({ setBoundaries, boundaryAlert }) {
    return (
        <Col gap={16}>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Updward Boundary</Label>
                    <Input type="number" onChange={e => setBoundaries(e.target.value, 'up')}
                        value={boundaryAlert.upwardBoundary ?? ''}
                    />
                </Row>
            </Col>
            <Col gap={8}>
                <Row gap={8} className="alert-def-input">
                    <Label>Downward Boundary</Label>
                    <Input type="number" onChange={e => setBoundaries(e.target.value, 'down')}
                        value={boundaryAlert.downwardBoundary ?? ''}
                    />
                </Row>
            </Col>
        </Col>
    )
}

export default BoundaryAlert;